import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import React from 'react';
import { connect } from 'react-redux';
import styles from './StepBar.module.scss';
import { steps } from './steps';
import { StepConnector } from '@mui/material';
import { goToStep } from '../../../redux/agreement/actions';

const Stepbar = ({
	stepbar,
	goToStep,
	loadedStepbar,
	clientInfo,
	productAvailability,
}) => {
	console.log('loadedStepbar', loadedStepbar);

	const checkIfClickable = (index) => {
		if (Number(index) === 0 && clientInfo) {
			return goToStep(index);
		} else if (Number(index) === 1 && productAvailability) {
			return goToStep(index);
		} else if (Number(index) === 2 && clientInfo && productAvailability) {
			return goToStep(index);
		}
	};
	return (
		<div className={styles.stepbarWrapper}>
			<Stepper
				activeStep={loadedStepbar ? loadedStepbar : stepbar}
				connector={<StepConnector style={{ color: 'red' }} />}
				className={styles.stepperComp}
			>
				{steps.map((step, index) => (
					<Step key={step.label}>
						<StepLabel
							className={styles.stepLabel}
							onClick={() => checkIfClickable(index)}
						>
							{step.label}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	stepbar: state.agreement.stepbar,
	loadedStepbar: state.agreement?.agreementById?.stepbar,
	clientInfo:
		state.agreement?.agreementById?.clientInfo?.firstName ||
		state.agreement?.agreementById?.clientInfo?.corporationName,
	productAvailability:
		state.agreement?.agreementById?.productAvailability?.lotId,
});

export default connect(mapStateToProps, { goToStep })(Stepbar);
